exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signature[data-v-b285b588] {\n    border: 1px solid;\n}\n.menu-signature[data-v-b285b588] {\n    position: absolute;\n    right: 10px;\n    top: -10px;\n}\n", ""]);

// exports
